import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core'
import { InlineEditCellDirective } from '../inline-edit-cell'
import { FormControl } from '@angular/forms'

@Component({
  selector: 'jml-lib-string-cell',
  templateUrl: './string-cell.component.html',
  styleUrls: ['../inline-edit-cell.scss']
})
export class StringCellComponent extends InlineEditCellDirective implements OnChanges {
  // newValue: string | undefined;
  override newValue: FormControl

  private initFormControl() {
    this.newValue = new FormControl(this.rowData?.[this.fieldName] ? this.rowData?.[this.fieldName] : '')
  }

  onKeyupEnter() {
    if (!this.mandatory || this.newValue.value) {
      this.isEdited = false
      const updatedRowData = {
        ...this.rowData,
        [this.fieldName]: this.newValue.value
      }
      this.completeCellEdit.emit({ data: updatedRowData, field: this.fieldName })
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.rowData) {
      this.initFormControl()
    }
  }

  triggerEdit() {
    this.initFormControl()
    setTimeout(() => {
      this.isEdited = true
    }, 10) // 10 ms delay to avoid that StringInputComponent receives that click
  }

  override abortCellEdit() {
    this.isEdited = false
  }
}
